import { Link } from "react-router-dom";

export default function HeaderStrip() {
  return (
    <div className="bg-primary py-3">
      <div className="max-w-7xl mx-auto px-4 md:px-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-1">
        <div className="flex items-center gap-2 text-xs text-white">
          <Link to="/" className="hover:text-[#fefce8] transition-colors">Home</Link>
          <span><i className="ri-arrow-right-s-line text-white/70" /></span>
          <Link to="/service-areas" className="hover:text-[#fefce8] transition-colors">Services</Link>
          <span><i className="ri-arrow-right-s-line text-white/70" /></span>
          <span className="text-white/80">Weatherstripping</span>
        </div>
        <span className="text-xs text-white font-medium">Same-Day Available</span>
      </div>
    </div>
  );
}